"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Search(_a) {
    var channel = _a.channel, onChange = _a.onChange;
    var _b = ra_fetch_1.useApi('backend').index('videos', {
        page: 1,
        paginate: 10,
        channel_id: channel.id,
        resource: 'VideoFull',
    }), videos = _b[0], setVideo = _b[1], params = _b[2], setParams = _b[3];
    var _c = storybook_1.Hooks.useSearch(params, setParams), search = _c[0], setSearch = _c[1];
    function loadMore(page) {
        setParams(__assign(__assign({}, params), { page: page }), page !== 1);
    }
    return React.createElement("div", { className: 'storybook-videos-search-list' },
        React.createElement(storybook_1.Forms.Input, { className: 'mb-6 search-input', placeholder: 'Zoeken...', value: search, onChange: setSearch }),
        search && React.createElement("span", { className: 'search-results' },
            videos.meta.total,
            " ",
            videos.meta.total > 0 ? 'resultaten' : 'resultaat'),
        videos.data.length !== 0 && search && React.createElement(storybook_1.Lists.List, { type: 'grid' }, videos.data.map(function (video, index) { return React.createElement(storybook_1.Videos.Card, { key: index, onClick: function () { return onChange(video); }, video: video }); })),
        React.createElement(storybook_1.Lists.Lazyload, { loading: Boolean(videos.loading && search.length), load: videos.meta.current_page !== videos.meta.last_page, onEnter: function () { return loadMore(videos.meta.current_page + 1); } }));
}
exports.default = Search;
